module.exports = __webpack_public_path__ + "media/images/icons/fb-9990f83f17ec98e64058a06404c6f5a3.svg";